import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import validator from 'validator';
import { lang } from '../lang';

class Support extends Component {
  constructor(props) {
    super(props);
    this.cursor = 'hand';
    this.btn_text = lang.sup_send;
    const params = new URLSearchParams(props.location.search);
    this.status = params.get('s');
  }

  state = {
    name: '',
    email: '',
    subject: '',
    description: '',
    isButtonDisabled: false,
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e, formData, inputs) => {
    this.setState({
      isButtonDisabled: true,
    });
    this.cursor = 'wait';
    this.btn_text = lang.sup_sending;
  };

  handleErrorSubmit = (e, formData, errorInputs) => {
    this.setState({
      isButtonDisabled: false,
    });
  };

  isSuccess = () => {
    if (this.status === 'success') {
      return (
        <div className="alert alert-success text-center" role="alert">
          {lang.sup_sent}
        </div>
      );
    } else if (this.status === 'failed') {
      return (
        <div className="alert alert-danger text-center" role="alert">
          {lang.sup_failed}
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <div className="main-container -support">
        <Helmet>
          <title>{lang.sup_title}</title>
          <meta name="description" content={`${lang.sup_desc}`} />
        </Helmet>
        <this.isSuccess />
        <h1 className="support-head">{lang.support}</h1>
        <p className="support-subhead lead text-justify">{lang.sup_content}</p>
        <ValidationForm
          className="support-form"
          onSubmit={this.handleSubmit}
          onErrorSubmit={this.handleErrorSubmit}
          method="POST"
          action={`https://beestripe.sirportly.com/remote_form/${
            process.env.REACT_APP_SIRPORTLY_ID
          }`}
        >
          <div className="support-formgroup">
            <div className="col-sm textarea-div">
              <TextInput
                name="ticket[name]"
                id="name"
                required
                placeholder={`${lang.sup_fullname}`}
                errorMessage={{ required: `${lang.sup_error_name}` }}
                value={this.state.name}
                onChange={this.handleChange}
              />
            </div>

            <div className="col-sm textarea-div">
              <TextInput
                name="ticket[email]"
                type="email"
                required
                id="email"
                placeholder={`${lang.sup_email}`}
                value={this.state.email}
                validator={validator.isEmail}
                errorMessage={{ validator: `${lang.sup_error_email}` }}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="support-formgroup">
            <div className="col-sm textarea-div">
              <TextInput
                name="ticket[subject]"
                id="subject"
                required
                placeholder={`${lang.sup_subject}`}
                errorMessage={{ required: `${lang.sup_error_subject}` }}
                value={this.state.subject}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="support-form-group">
            <div className="col-sm textarea-div -textarea">
              <TextInput
                name="ticket[message]"
                multiline
                required
                id="description"
                errorMessage={{ required: `${lang.sup_error_message}` }}
                value={this.state.description}
                onChange={this.handleChange}
                placeholder={`${lang.sup_message}`}
                rows="8"
              />
            </div>
          </div>

          <div className="support-formgroup btn-area">
            <div className="col-sm">
              <button
                type="submit"
                className="primary-btn -block"
                disabled={this.state.isButtonDisabled}
                style={{ cursor: this.cursor }}
              >
                {this.btn_text}
              </button>
            </div>
          </div>
        </ValidationForm>
      </div>
    );
  }
}

export default Support;



// WEBPACK FOOTER //
// ./src/pages/Support.js